import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Ship } from '../../_models/ship';
import { SaleOfferFilter, SaleOffer, SaleOfferStatus } from 'app/_models/commercialization';
import { SaleOfferService } from 'app/_services/commercialization.service';

@Component({
  selector: 'app-sale-offers-filter',
  templateUrl: './sale-offers-filter.component.html',
})
export class SaleOffersFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Input() loading: boolean;
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: SaleOfferFilter;
  date: Date;
  saleOfferStatus: SaleOfferStatus[];
  selectedSaleOfferStatus: SaleOfferStatus;

  constructor(
    private fb: FormBuilder,
    private saleOfferService: SaleOfferService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();
    this.form = fb.group({
      date: [''],
      status: [''],
    });
  }

  ngOnInit() {
    this.filter = new SaleOfferFilter(this.filterParams);

    if (this.filter.date) {
      this.date = new Date(this.filter.date);
    }
    this.getSaleOfferStatus();
  }

  onSubmit() {
    this.filter.date = '';
    if (this.date) {
      this.date.setHours(23);
      this.filter.date = this.date.toISOString().substring(0, 10);
    }
    if (this.selectedSaleOfferStatus) {
      this.filter.status = this.selectedSaleOfferStatus['value'];
    } else {
      this.filter.status = '';
    }
    this.router.navigate(['/sale-offers', SaleOfferFilter.serializeRouterParams(this.filter)]);
  }
  getSaleOfferStatus() {
    this.saleOfferService.getStatus().subscribe(
      (data) => {
        const saleOfferStatus = SaleOffer.generateCollectionFromApi(data['actions']['POST']['status']['choices']).filter(
          (status) => status.value === 'reserved' || status.value === 'confirmed'
        );
        this.saleOfferStatus = this.parseDropdownResults(saleOfferStatus, new SaleOfferStatus(), 'display_name', false);
        this.selectedSaleOfferStatus = saleOfferStatus.find((status) => status.value === this.filter.status);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/sale-offers/sale-offers-filter/sale-offers-filter.component.ts